<!-- Desktop announcement modal -->
<div class="cdm-overlay" *ngIf="modalVisible" (click)="onOverlayClick($event)">
  <div class="cdm-modal">
    <div class="cdm-hero">
      <button class="cdm-close" (click)="closeModal()" aria-label="Kapat">&#x2715;</button>
      <img src="assets/img/mailing/mockups.png" class="cdm-device" alt="Cardata Mobil">
    </div>
    <div class="cdm-content">
      <h2 class="cdm-title">Yeni Cardata Mobil Yayında</h2>
      <p class="cdm-desc">
        Yenilenen arayüzü ve güçlü altyapısıyla araç değerleme artık çok daha hızlı.
        Hemen indirin, dilediğiniz an dilediğiniz yerden sorgulayın.
      </p>
      <div class="cdm-store-row">
        <a [href]="playStoreUrl" target="_blank" rel="noopener" (click)="closeModal()">
          <img src="assets/img/mailing/btn-playstore.png" alt="Google Play'den İndir" class="cdm-store-img">
        </a>
        <a [href]="appStoreUrl" target="_blank" rel="noopener" (click)="closeModal()">
          <img src="assets/img/mailing/btn-appstore.png" alt="App Store'dan İndir" class="cdm-store-img">
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Mobile install banner -->
<div class="cdb-banner" *ngIf="bannerVisible">
  <div class="cdb-top">
    <span class="cdb-icon-wrap">
      <img src="assets/img/mailing/cardata-logo-square.png" class="cdb-icon" alt="Cardata">
    </span>
    <div class="cdb-texts">
      <p class="cdb-subtitle">Daha hızlı bir deneyim için uygulamada açın</p>
    </div>
    <button class="cdb-close" (click)="closeBanner()" aria-label="Kapat">&#x2715;</button>
  </div>
  <button class="cdb-cta" (click)="openApp()">Uygulamada Aç</button>
</div>
